import { Component, Input, TemplateRef } from '@angular/core';
import { DynamicFieldModel } from '../../../index';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-ui-dynamic-form-checkbox',
  imports: [NgTemplateOutlet],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel }"></ng-container>
    } @else {}
  `,
  styles: ``,
})
export class DynamicFormCheckboxComponent {
  @Input() template?: TemplateRef<unknown>;
  @Input({ required: true }) fieldModel!: DynamicFieldModel;
}
